module.exports = __webpack_public_path__ + "img/farzana-christopher-25.b4aed080.jpg";